export class OrderStatus {
  public static HELD = "Held";
  public static WORKING = "Working";
  public static PENDING = "Pending";
  public static FILLED = "Filled";
  public static CANCELLED = "Cancelled";
  public static PARTIAL_FILLED = "Partially Filled";
  public static PARTIAL_FILLED_HELD = "Partially Filled & Held";
  public static PARTIAL_FILLED_CANCELLED = "Partially Filled & Cancelled";
  public static PENDING_HELD = "Pending & Held";
}

export class OrderBookFilterType {
  public static ALL = "All";
  public static WORKING = "Working";
  public static HELD = "Held";
  public static CANCELLED = "Cancelled";
  public static WITH_FILLS = "With Fills";
}
